import { loadCacheBreaker } from "@goodgamestudios/core";

window.setLoadingScreenProgress(25);
loadCacheBreaker();
